import React, { useMemo } from 'react';
import { Voni, VoniConfig } from '@voniai/nodejs';
import { VoniContext } from './VoniContextObject';

export interface VoniProviderProps {
  config: VoniConfig;
  children: React.ReactNode;
}

export const VoniProvider: React.FC<VoniProviderProps> = ({ config, children }) => {
  const client = useMemo(() => {
    // Try to auto-detect API key from common frontend environment variables
    let apiKey = config.apiKey;
    
    if (!apiKey) {
      try {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (typeof process !== 'undefined' && (process as any).env) {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          const env = (process as any).env;
          apiKey = env.REACT_APP_VONI_API_KEY || env.NEXT_PUBLIC_VONI_API_KEY || env.VONI_API_KEY;
        }
      } catch (e) {
        // Ignore process access errors
      }

      if (!apiKey) {
        try {
          // eslint-disable-next-line @typescript-eslint/no-explicit-any
          if (typeof import.meta !== 'undefined' && (import.meta as any).env) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const env = (import.meta as any).env;
            apiKey = env.VITE_VONI_API_KEY || env.VONI_API_KEY;
          }
        } catch (e) {
          // Ignore import.meta access errors
        }
      }
    }

    return new Voni({
      ...config,
      apiKey
    });
  }, [config]);

  return (
    <VoniContext.Provider value={{ client }}>
      {children}
    </VoniContext.Provider>
  );
};
